import { render, staticRenderFns } from "./PraticaRow.vue?vue&type=template&id=6dc0151d&scoped=true&"
import script from "./PraticaRow.vue?vue&type=script&lang=js&"
export * from "./PraticaRow.vue?vue&type=script&lang=js&"
import style0 from "./PraticaRow.vue?vue&type=style&index=0&id=6dc0151d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc0151d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dc0151d')) {
      api.createRecord('6dc0151d', component.options)
    } else {
      api.reload('6dc0151d', component.options)
    }
    module.hot.accept("./PraticaRow.vue?vue&type=template&id=6dc0151d&scoped=true&", function () {
      api.rerender('6dc0151d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/PraticaRow.vue"
export default component.exports